import { Save as SaveIcon } from '@mui/icons-material';
import {
  Button,
  CardActions,
  CardContent,
  Grid,
  TextField,
} from '@mui/material';
import type { FC } from 'react';
import type { Issue } from 'validata';
import { CenterCard } from '../../components/page-layout/center-card.js';
import { formatIssues } from '../../utils/issues.js';

export interface SetPasswordData {
  confirmPassword: string;
  password: string;
}

export interface ViewProps<T> {
  data: T;
  issues: Map<string, Issue[]>;
  patchData: <K extends keyof T, V extends T[K]>(key: K, value: V) => void;
  save: () => void;
}

export const SetPasswordView: FC<ViewProps<SetPasswordData>> = ({
  data,
  issues,
  patchData,
  save,
}) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        save();
      }}
    >
      <CenterCard>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                autoComplete="new-password"
                error={issues.has('password')}
                fullWidth
                helperText={formatIssues(issues.get('password'))}
                id="password"
                label="Password"
                name="password"
                onChange={(event) => patchData('password', event.target.value)}
                required
                type="password"
                value={data.password}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                autoComplete="new-password"
                error={issues.has('confirmPassword')}
                fullWidth
                helperText={formatIssues(issues.get('confirmPassword'))}
                id="confirmPassword"
                label="Confirm Password"
                name="confirmPassword"
                onChange={(event) =>
                  patchData('confirmPassword', event.target.value)
                }
                required
                type="password"
                value={data.confirmPassword}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ justifyContent: 'end', mb: 2, mx: 1 }}>
          <Button
            color="primary"
            startIcon={<SaveIcon />}
            type="submit"
            variant="contained"
          >
            Set Password
          </Button>
        </CardActions>
      </CenterCard>
    </form>
  );
};
